<template>
  <transition name="fade" mode="out-in">
    <div
      v-if="state.state === 'img'"
      key="img"
    >
      <img
        :src="`https://storage.googleapis.com/cartografiadigital/records_icons/${record}.png`"
      />
    </div>
    <div 
      class="mosaic-piece black"
      v-else-if="state.state === 'black'"
      key="black"
    >
    </div>
    <div 
      class="mosaic-piece"
      v-else
      key="white"
    >
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MosaicPiece',
  props: [
    'state',
    'records',
  ],
  methods: {
    switch: function(){
      const t = this.t;
      this.intervalid1 = setInterval(function(){
        this.on = !this.on;
        this.img = this.on ? Math.random() > .6 : false;
      }.bind(this), t);
      this.t = 2000 + (Math.random() * 30000);
    },
    turnOn: function(){
      this.on = true;
      this.state = Math.random() > .5 ? 'black' : 'img';
    },
    turnOff: function(){
      this.on = false;
      this.state = null;
    }
  },
  computed: {
    record() {
      return this.records[Math.floor(Math.random() * this.records.length)];
    }
  }
}
</script>

<style scoped>

  .mosaic-piece {
    background-color: var(--white);
  }

  .mosaic-piece.black {
    background-color: var(--black);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .8s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

</style>